import { FileText } from 'lucide-react';
import { data, nomeDeArquivo } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/**
 * Lista de 30/10 (item 10): arquivos de Documentos (pelo nome, sem acento). O nome passa pelo `nomeDeArquivo` (modo
 * discreto). Abre o drawer (`?id=`); a lista lê `?busca=` ("Ver todos").
 */
interface DocumentoBusca {
  id: string;
  nome: string;
  registro_titulo: string | null;
  updated_at: string;
}

export const buscaDocumentos: FonteBuscaGlobal[] = [
  {
    chave: 'arquivos',
    permissao: 'documentos.ver',
    pagina: 'documentos.arquivos',
    grupo: 'buscaGlobal.arquivos',
    posicao: 95,
    icone: FileText,
    item: (d: DocumentoBusca) => ({ id: d.id, rotulo: nomeDeArquivo(d.nome, d.registro_titulo), detalhe: data(d.updated_at), link: `${caminhoDaAba('documentos', 'arquivos')}?id=${d.id}` }),
    verTodos: (termo) => `${caminhoDaAba('documentos', 'arquivos')}?busca=${encodeURIComponent(termo)}`,
  },
];
